import React, { useEffect, useState } from 'react'
import CMS from '../../../../components/cms/CMS'
import PageBanner from '../../../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import CrudSliderContent from './CrudSliderContent'
import { fetchSliderContentGetAllBySlider } from '../../../../redux/slices/sliderContentGetAllBySliderSlice'
import { fetchSliderContentDelete } from '../../../../redux/slices/sliderContentDeleteSlice'
import { fetchSliderContentSort } from '../../../../redux/slices/sliderContentSortSlice'
import { fetchSliderGet } from '../../../../redux/slices/sliderGetSlice'
import { SortableList } from '../../../../components/form/SortedBy'

const SliderContentPage = () => {
    const [modal, setModal] = useState(false)
    const [changed, setChanged] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const slider = useSelector((state) => state.sliderGet.data)
    const lang = useSelector((state) => state.lang.lang)
    const status = useSelector((state) => state.sliderContentGetAllBySlider.status)
    const slidersBySlider = useSelector((state) => state.sliderContentGetAllBySlider.data)
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const { id } = useParams()

    const getData = async () => {
        await dispatch(fetchSliderContentGetAllBySlider({ id: id }))
        await dispatch(fetchSliderGet({ id: id }))
    }

    const deleteData = async (id) => {
        await dispatch(fetchSliderContentDelete({ id: id }))
        getData()
    }

    const handleSorted = (newList) => {
        slidersBySlider.forEach(async (oldItem, oldIndex) => {
            const newIndex = newList.findIndex(item => item.id === oldItem.id);
            await dispatch(fetchSliderContentSort({ id: oldItem.id, sort: newIndex + 1 }))
            setChanged(true)
            getData()
        });
    };

    useEffect(() => {
        getData()
    }, [dispatch, id, changed])

    return (
        <CMS>
            {
                slider ? <>
                    <PageBanner
                        modal={modal}
                        setModal={setModal}
                        title={slider?.title[lang]}
                        description={t("slider_management_desct")}
                        buttonText={t("slider_content_add")}
                    />

                    {status === "succeeded" ?
                        <SortableList
                            setModal={setModal}
                            list={slidersBySlider ? [...slidersBySlider].sort((a, b) => a.sort - b.sort) : []}
                            onChange={handleSorted}
                            setChanged={setChanged}
                            deleteData={deleteData}
                            setSelectedItem={setSelectedItem}
                        /> : null
                    }

                    <CrudSliderContent
                        showMenu={modal}
                        setShowMenu={setModal}
                        setChanged={setChanged}
                        setSelectedItem={setSelectedItem}
                        lang={lang}
                        id={id}
                        selectedItem={selectedItem}
                        t={t}
                    />
                </> : null
            }
        </CMS>
    )
}

export default SliderContentPage
